import Cookies from "js-cookie";

namespace Experiment {
  export type Name =
    | "solidCreditAccountActivation"
    | "solidCreditAccountDetails";

  export namespace Cookie {
    const prefix = "kikoff-experiment-";

    export const get = (name: Name) => Cookies.get(`${prefix}${name}`);
  }
}

export default Experiment;
